<template>
  <div class="text-center">
    <!-- Title -->

    <div v-if="fullPackageList.length != 0" class="row mx-0 text-center">
      <b-col cols='3'></b-col>
      <b-col cols='6'>
        <h3 class="gridHeaderText my-3">{{ (title)? title : $t('product.list.containerTitle.hotsalePackage') }}</h3>
      </b-col>
      <b-col cols='3'></b-col>
    </div>
    <!-- Content -->
    <div class="row mx-1 align-items-center">
      <div v-for="packages in fullPackageList" class="col-6 px-0 my-1">
        <PackageCard :value="packages"></PackageCard>
      </div>
      <div v-if="currentRole == 'K' && shopProductList " @click=" backToFulllist" class="pointer col-6 addBtnContainer px-0 my-2" :style="{height:addBtnHeight+'px'}">
        <i class="fa fa-plus primaryColorText" style=" font-size: 2rem !important; line-height: 100px;"></i>
        <p class="px-2 text-center addBtnText">
          {{$t('product.list.addBtnHint1')}}<br /><br />
          {{$t('product.list.addBtnHint2')}} </p>
      </div>
    </div>
    <!-- Load More Button -->
    <x-button @click.native="loadMore()" v-if="showLoadMore" class="my-3 loadMoreBtn" style="width:50%" type="primary" :plain="true">{{$t('product.list.loadMore')}}</x-button>
    
  </div>
</template>
<script type="text/javascript">
import { FITFormCard, FITCheckbox, FITSelect, FITTextInput, FITInputTag, FITButton } from '@/components'
import { mapGetters } from 'vuex'
import PackageCard from './PackageCard'
import Cookies from 'js-cookie'
import { TransferDom, Alert } from 'vux'

var searchDelay = "";

export default {
  name: 'GridContainer',
  directives: {
    TransferDom
  },
  components: {
    Alert,
    FITCheckbox,
    FITSelect,
    FITTextInput,
    FITInputTag,
    FITButton,
    FITFormCard,
    PackageCard
  },
  props: {
    title: {
      type: String,
    },
    VuexModule: {
      type: String,
      default: '',
    },
    shopProductList: {
      type: Boolean,
      default: false
    },
    reload: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      count: 10,
      addBtnHeight: 220,
      shopModule: this.VuexModule,
      showAlert: false,
      alertMsg: '',
      alertBtnText: this.$t('kol.header.confirm'),
    }
  },
  created() {},
  mounted() {
    if (!this.shopModule) {
      this.shopModule = this.getRouteStatus.module;
    }


    let searchParam = {
      search: '',
      categoryID: '0'
    };
    this.getPackageList(this.shopModule, searchParam);
    // this.$store.commit('setSearchCategory', { categoryID: '12' });
  },
  watch: {
    searchParam: {
      handler: function(newVal, oldVal) {
        clearTimeout(searchDelay);
        searchDelay = setTimeout(() => {
          // console.log(newVal);
          this.getPackageList(this.shopModule, newVal);
        }, 200);

      },
      deep: true
    },
    // reload(newVal){
    //   if(val){
    //       this.$store.commit('setSearchCategory', { categoryID: '12' });
    //   }
    // }
  },
  computed: {
    ...mapGetters([
      'getImageUrl',
      'getTranslatedData',
      // 'getCardQuantityByID', // changed to getPackageQuantityByID
      'getRouteStatus',
      'getExchangePrice'
    ]),
    copyData() {
      let string = document.title + '\n\n';
      let copyData = 'https://mobile.kolpartner.com' + this.$router.currentRoute.fullPath;
      string += copyData;
      // console.log(string);
      return string;

    },
    searchParam() {
      return this.$store.state.searchParam;
    },
    currentRole() {
      return Cookies.get('role');
    },
    currentRoute() {
      return this.$router.currentRoute;
    },
    fullPackageList() {
      switch (this.shopModule) {
        case 'Packages':
          return this.$store.getters['Package/fullPackageList'];
          break;
        case 'Shop':
          return this.$store.getters['Shop/KOLPackages'];
          break;
      }
      return [];
    },
    showLoadMore(){
      if(this.count>this.fullPackageList.length){
        return false
      }
      else{
        return true
      }
    }

  },
  methods: {
    copySuccess(e) {
      // console.log('Success: ' + e );
    },
    copyError(e) {
      // console.log('Error: ' + e );
    },
    shareCurrentPage() {
      this.alertBtnText = this.$t('shop.detail.shareConfirmText');
      this.alertMsg = this.$t('shop.detail.shareBodyText');
      this.showAlert = true;
    },
    backToFulllist() {
      if (Cookies.get('role') == 'K') {
        // this.$store.commit('setFooterCurrentTab',{currentTab:0});
        this.$router.push('/product');
      }
    },
    loadMore() {
      this.count += 10;
      this.getPackageList(this.getRouteStatus.module, this.searchParam);
    },
    getPackageList(module, searchParam = {}) {
      let param = {
        count: this.count,
        orderby: 'ID',
        region:Cookies.get('region'),
        loadGroupBuy:1,
        type:'G',
      };
      let search = JSON.parse(JSON.stringify(searchParam));
      param = Object.assign(search, param)
      // console.log(param);
      // console.log(module);
      switch (module) {
        case 'Packages':
          // Hardcode for Exhibition
          this.$store.dispatch('Package/getFullPackageList', param).then((json) => {

            })
            .catch((error) => {
              switch (error.status) {
                case 401:
                case 403:
                  this.$router.push('/login?type=1');
                  break;
              }
            });
          break;
        case 'Shop':
          let link = this.currentRoute.query.link;
          param['link'] = link;
          this.$store.dispatch('Shop/getKOLProducts', param);
          break;
      }
    }
  },
}

</script>
<style type="text/css">
.addBtnContainer {
  height: 200px;
  background-color: white;
  border: 2px dashed #dc3545;
}

.addBtnText {
  color: #AAA;
  font-size: 14px;
}

.gridHeaderText {
  color: #4A90E2 !important;
}

.loadMoreBtn {
  background: white !important;
}
.shareBtn {
  margin: 18px 2px !important;
  font-size: 0.8rem;
  padding: 2px 6px;
  float: right;
  cursor: pointer;
  color:#64a2e5 !important;
  border-color: #64a2e5;
  background-color: #fff !important;
}
.shareBtn:hover,.shareBtn:active{
  border-color:#64a2e5 !important;
}
</style>



// WEBPACK FOOTER //
// src/Package/components/GridContainer.vue